import type { ReactNode } from "react"

import { useTranslation } from "react-i18next"

import { Maximize2, Minimize2, X } from "@/components/icons"
import { Button } from "@/components/ui/button"

type ContentSidebarHeaderProps = {
  title?: ReactNode
  actions?: ReactNode
  isFocused: boolean
  isFocusable: boolean
  closeable: boolean
  onToggleFocus: () => void
  onClose: () => void
}

export function ContentSidebarHeader({
  title,
  actions,
  isFocused,
  isFocusable,
  closeable,
  onToggleFocus,
  onClose,
}: ContentSidebarHeaderProps) {
  const { t } = useTranslation()

  return (
    <div className="flex shrink-0 items-center justify-between border-b p-2">
      <h3 className="mr-2 flex-1 truncate text-sm font-semibold">
        {title ?? t("analysispanel.citation", { defaultValue: "Panel" })}
      </h3>
      <div className="flex items-center gap-1">
        {actions}
        {isFocusable && (
          <Button
            className="h-8 w-8 shrink-0 p-0"
            size="icon"
            variant="ghost"
            aria-label={
              isFocused
                ? t("analysispanel.exit_focus", { defaultValue: "Exit focus mode" })
                : t("analysispanel.focus", { defaultValue: "Focus mode" })
            }
            onClick={onToggleFocus}
          >
            {isFocused ? <Minimize2 className="size-4" /> : <Maximize2 className="size-4" />}
          </Button>
        )}
        {closeable && (
          <Button
            aria-label={t("analysispanel.close", { defaultValue: "Close" })}
            className="h-8 w-8 shrink-0 p-0"
            size="icon"
            variant="ghost"
            onClick={onClose}
          >
            <X className="size-4" />
          </Button>
        )}
      </div>
    </div>
  )
}
